import Footer from "../../../../Components/Footer/Footer";
import { Button, Card, Form } from "react-bootstrap";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-hot-toast';
import Loading from 'react-fullscreen-loading';
import '../Signin/Signin.css';
import logo from '../../../../assets/Logo/cadomationnewlogo.webp';
import AuthLeftPanel from "../../../User/Auth/LeftAuthPanel/AuthLeftPanel";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ChangePassword(){
    const navigate = useNavigate();
    const [screenloader,setScreenloader] = useState(false);

    const [password,setPassword] = useState("");
    const [confirmPassword,setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [userCode,setUserCode] = useState("");
    const [timer, setTimer] = useState(300);
    const Param1 = useParams();
    const location = useLocation();
    const loc = location.pathname === `/ChangePassword/${Param1}` ? true : false;
    const email = Param1.email;
    const [isMobile, setIsMobile] = useState(false);
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    
      useEffect(() => { const checkScreen = () => setIsMobile(window.innerWidth <= 600); 
            checkScreen(); window.addEventListener("resize", checkScreen); 
                return () => window.removeEventListener("resize", checkScreen); }, []);
    
      useEffect(() => {
        if (timer > 0) {
          const interval = setInterval(() => {
            setTimer(prevTimer => prevTimer - 1);
          }, 1000);
    
          return () => clearInterval(interval);
        }
    }, [timer]);
    
    const SendAgain=async(e)=>{
        await ResetEmail();
    }

    const ResetEmail=async()=>{
        await axios.post(`${process.env.REACT_APP_API_URL}/auth/forgotpasswordrequest`,{
            email:email,
        })
        .then(res=>{
            setScreenloader(false);
            if(res.data && res.data.status !== undefined){
                if(res.data.status===1){
                    toast.success("Verification Code sent to your email!");
                    setTimer(300);
                    return;
                }else{
                    toast.error(res.data.message);
                    return;
                }
            }
        })
        .catch(er=>{
            setScreenloader(false);
            if(er.response.data?.message){
                toast.error(er.response.data?.message);
                return;
            }else{
                console.log(er)
                toast.error("Unable to connect to Server");
                return;
            }
        })
    }
const handlePasswordSubmit = async (e) => {
  e.preventDefault();
  setPasswordError("");
  setConfirmPasswordError("");

  let isValid = true;
  if (password === "") {
    setPasswordError("Password is required");
    isValid = false;
  } else if (!isStrongPassword(password)) {
    setPasswordError(
      "Password should be strong (greater than 8 characters, include uppercase, lowercase, and numbers)"
    );
    isValid = false;
  }
  if (confirmPassword === "") {
    setConfirmPasswordError("Confirm Password is required");
    isValid = false;
  } else if (password !== confirmPassword) {
    setConfirmPasswordError("Passwords do not match");
    isValid = false;
  }
  if (isValid) {
    setScreenloader(true);
    await ChangeAccountPassword(); 
  }
};
const isStrongPassword = (password) => {
        const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return strongPasswordRegex.test(password);
      };
      const toggleShowPassword = () => {
        setShowPassword(!showPassword);
      };
      const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
      };
    const ChangeAccountPassword=async()=>{
        await axios.post(`${process.env.REACT_APP_API_URL}/auth/ChangePassword`,{
            email: email,
            password: password,
            usercode: userCode
        })
        .then(res=>{
            setScreenloader(false);
            if(res.data && res.data.status !== undefined){
                if(res.data.status===1){
                    toast.success("Password Changed Successfully");
                    navigate(`/Signin`, { replace: true });
                    return;
                }else{
                    toast.error(res.data.message);
                    return;
                }
            }
        })
        .catch(er=>{
            setScreenloader(false);
            if(er.response.data?.message){
                toast.error(er.response.data?.message);
                return;
            }else{
                console.log(er)
                toast.error("Unable to connect to Server");
                return;
            }
        })
    }

    // const Submit = async (e) => {
    //     e.preventDefault();
    //     if (password !== confirmPassword) {
    //     toast.error("Passwords do not match")  
    //     return; 
    //     }
    //     if (!isStrongPassword(password)) {
    //     toast.error("Password should be strong (greater than 8 characters, include uppercase, lowercase, and numbers)")  
    //     return; 
    //     }
    //     if (!email) {
    //       toast.error("Email not found!");
    //       return; 
    //     }
      
    //     setScreenloader(true);
    //     await ChangeAccountPassword();
    //   }
 

    return( 
        <>
        <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
        <div className="signin-page">
            <div className="auth-wrapper">
              <AuthLeftPanel />
              <div className="right-panel">
                <Card className="signin-card"> <Card.Body>
                  <div className="text-center mb-3">
                    <div className="logo-wrapper text-center mb-4">
                      <img src={logo} alt="Cadomation" className="signin-logo" />
                    </div>   
                    <h3 className="form-title">Change Password</h3>      
                      <p className="form-sub">
                        An email with a validation code will be sent to your email for verification.
                      </p>
                  </div>
                  <Form  onSubmit={handlePasswordSubmit} className="w-100">
                    <Form.Group className="mb-3" controlId="verificationCode">
                      <Form.Label>Verification Code</Form.Label>
                      <Form.Control
                        className="form-input"
                        type="number"
                        placeholder="Code"
                        required
                        value={userCode}
                        onChange={e => setUserCode(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="password">
                      <Form.Label>New Password</Form.Label>
                      <div className="position-relative">
                      <Form.Control
                        className="form-input pe-5"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        required
                        value={password}
                        onChange={e => {setPassword(e.target.value); setPasswordError("");}}
                        isInvalid={!!passwordError}
                      />
                       <span
                          className="password-toggle"
                          onClick={toggleShowPassword}
                          style={{ right: passwordError ? "40px" : "14px" }}
                          role="button"
                          tabIndex={0}
                          aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                         </span>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {passwordError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  
                    <Form.Group className="mb-3" controlId="confirmPassword">
                      <Form.Label>Confirm New Password</Form.Label>
                      <div className="position-relative">
                      <Form.Control
                        className="form-input pe-5"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Password"
                        required
                        value={confirmPassword}
                        onChange={e => {setConfirmPassword(e.target.value); setConfirmPasswordError("");}}
                        isInvalid={!!confirmPasswordError}
                      />
                      <span
                        className="password-toggle"
                        onClick={toggleShowConfirmPassword}
                        style={{ right: confirmPasswordError ? "40px" : "14px" }}
                        role="button"
                        tabIndex={0}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {confirmPasswordError}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <div className="d-grid">
                      <Button className="btn-signin" type="submit">
                        Change Password
                      </Button>
                      <Button
                        variant="outline-secondary"
                        type="button"
                        className="w-100 mt-2" 
                        onClick={() => navigate(-1)}
                      >
                        ← Back
                      </Button>                                   
                    </div>
                  </Form>
                  <div className="mt-3">
                    <p className="mb-0 text-center">
                      Didn't receive a code?{" "}
                      {!timer ? (
                        <span onClick={SendAgain} className="link-accent fw-bold">
                          Send again
                        </span>
                      ) : (
                        `Send again in ${Math.floor(timer / 60)}:${timer % 60 < 10 ? "0" : ""}${
                          timer % 60
                        }`
                      )}
                    </p>
                  </div>
                  </Card.Body> {isMobile && <Footer />} </Card>
              </div>
            </div>
        {!isMobile && <Footer />}
          </div>
        </>
    )
}